"use client";

import { Post } from "@forcode/domain";
import { MDXRemote } from "next-mdx-remote";
import { MDXComponents, PostShareButton } from "ui";

export default function PostContent({ post }: { post: Post }) {
  return (
    <>
      <MDXRemote {...post.content} components={MDXComponents} />
      {!post.meta.isDraft && <PostShareButton post={post} />}
    </>
  );
}
